(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerInner = document.querySelector('.header');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
		
		if (this.headerIsAlwaysSticky) this.reveal; 
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
		this.header.classList.add('shopify-section-header-sticky','shopify-section-header-always-sticky');
	};

	if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
		this.header.classList.remove('shopify-section-header-sticky');
	};

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (this.preventHide) return;
		requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (!this.preventReveal) {
		requestAnimationFrame(this.reveal.bind(this));
		} else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
			this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
		}
		} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (this.disclosures) {
			this.disclosures.forEach(disclosure => {
				disclosure.close(); 
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			if (this.disclosureLists) {
				this.disclosureLists.forEach(disclosureList => {
					disclosureList.setAttribute('hidden', true); 
				});
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    syncMainGalleryFromModal() {
      const modalId = this.id.replace('ProductModal-', '');
      const popupSliderEl = this.querySelector('.js-popup-slider');
      const popupSwiper = popupSliderEl?.swiper;

      if (!popupSwiper) return;

      const activeSlide = popupSwiper.slides[popupSwiper.activeIndex];
      const activeModalMediaId = activeSlide?.getAttribute('data-media-modal-id');

      if (!activeModalMediaId) return;

      const mainProduct = document.querySelector(`#MainProduct-${modalId}`);
      if (!mainProduct) return;

      const mainSliderEl = mainProduct.querySelector('.js-media-list');
      const subSliderEl = mainProduct.querySelector('.js-media-sublist');
      const mediaList = mainProduct.querySelector(`[data-section="product-media-${modalId}"]`);

      if (mediaList) {
        mediaList.querySelectorAll('[data-media-id]').forEach((item) => {
          item.classList.remove('active');
        });

        const activeMainItem = mediaList.querySelector(
          `[data-media-id="${activeModalMediaId}"]`
        );

        if (activeMainItem) {
          activeMainItem.classList.add('active');
        }
      }

      if (mainSliderEl?.swiper) {
        const targetSlide = mainSliderEl.querySelector(
          `[data-media-id="${activeModalMediaId}"]`
        );

        if (targetSlide) {
          const targetIndex = Array.from(mainSliderEl.swiper.slides).indexOf(targetSlide);
          if (targetIndex > -1) {
            mainSliderEl.swiper.slideTo(targetIndex, 0);
          }
        }
      }

      if (subSliderEl?.swiper) {
        const targetSubSlide = subSliderEl.querySelector(
          `[data-media-sub-id="${activeModalMediaId}"]`
        );

        if (targetSubSlide) {
          const targetSubIndex = Array.from(subSliderEl.swiper.slides).indexOf(targetSubSlide);
          if (targetSubIndex > -1) {
            subSliderEl.swiper.slideTo(targetSubIndex, 0);
          }
        }
      }

      const gridOrStackedToggle = mainProduct.querySelector(
        `.product__media-toggle[data-media-id="${activeModalMediaId}"]`
      );

      if (gridOrStackedToggle) {
        gridOrStackedToggle.click();
      }
    }

    hide() {
      this.syncMainGalleryFromModal();
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const mediaId = this.openedBy?.getAttribute('data-media-id');
      const popupSlider = this.querySelector('.js-popup-slider')?.swiper;

      if (popupSlider && mediaId) {
        const targetSlide = this.querySelector(
          `[data-media-modal-id="${mediaId}"]`
        );

        if (targetSlide) {
          const targetIndex = Array.from(popupSlider.slides).indexOf(targetSlide);
          if (targetIndex > -1) {
            popupSlider.slideTo(targetIndex, 0);
          }
        }
      }

      const activeMedia = this.querySelector(
        `[data-media-modal-id="${mediaId}"]`
      );

      const deferredMedia = activeMedia?.querySelector('deferred-media');

      if (
        deferredMedia &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      ) {
        deferredMedia.loadContent();
      }
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
